/* Leaflet a richiesta.

   Prima era importato staticamente: ~150 KB di JS e 11 KB di CSS su ogni pagina,
   e la mappa del footer scaricava i tile di OpenStreetMap (161 KB) appena aperta
   la pagina, anche se sta in fondo e quasi nessuno ci arriva. Ora la libreria
   arriva con la prima mappa che sta per entrare nello schermo. */

let leafletPromise = null;

window.loadLeaflet = function () {
    if (!leafletPromise) {
        leafletPromise = Promise.all([
            import("leaflet"),
            import("/node_modules/leaflet/dist/leaflet.css"),
        ]).then(([module]) => {
            const L = module.default ?? module;
            window.leaflet = L;
            // Il bundle UMD popola anche window.L: le view che usano la globale
            // continuano a funzionare senza modifiche.
            window.L = window.L || L;
            return window.L;
        });
    }
    return leafletPromise;
};

/* Disegna una mappa quando il contenitore sta per entrare nello schermo.
   Una mappa gia' in vista (pagina della sede) parte subito: l'osservatore
   scatta alla prima osservazione. */
window.whenMapVisible = function (id, init) {
    const element = document.getElementById(id);
    if (!element) {
        return;
    }

    const start = () => window.loadLeaflet().then((L) => init(L));

    if (!("IntersectionObserver" in window)) {
        start();
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                observer.disconnect();
                start();
            }
        },
        { rootMargin: "400px" }
    );
    observer.observe(element);
};
